import Link from 'next/link';
import { Trans } from 'next-i18next';
import { useRef } from 'react';
import FormikCheckbox from '@components/elements/FormikCheckbox/FormikCheckbox';
import ConsentSplitFields from '@components/modules/RegisterForm/ConsentSplitFields';
import useTransformLinksToExternal from '@components/modules/RegisterForm/hooks/useTransformLinksToExternal';
import INPUT_IDS from '@constants/inputs/userDataInputs';
import useAppConfig from '@hooks/useAppConfig';
import useAppModuleConfig from '@hooks/useAppModuleConfig';

const TermsAndConsentsFields = () => {
  const {
    data: {
      brand: { termsContent },
    },
  } = useAppConfig();
  const { appTerms } = useAppModuleConfig('Links');

  const serviceAgreementRef = useRef(null);

  useTransformLinksToExternal([serviceAgreementRef]);

  return (
    <div tw="grid gap-y-4 px-[5px]">
      <FormikCheckbox
        name={INPUT_IDS.SERVICE_AGREEMENT}
        label={
          termsContent ? (
            <span
              ref={serviceAgreementRef}
              dangerouslySetInnerHTML={{ __html: termsContent }}
            />
          ) : (
            <Trans
              i18nKey="$*input.appTerms.label"
              components={[
                <Link
                  key="0"
                  href={appTerms.link || ''}
                  target="_blank"
                  rel="noopener noreferrer"
                  tw="font-semibold"
                />,
              ]}
            />
          )
        }
        required={true}
      />
      <ConsentSplitFields lineClamp={5} />
    </div>
  );
};

export default TermsAndConsentsFields;
